(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
     
const WebiTimer = setInterval(countDown, 1000);
function countDown() {
  var countDownDate = new Date(document.querySelector('.wb_product_countdown').getAttribute('data-date')).getTime();
  var now = new Date().getTime();
  var distance = countDownDate - now;
  if (distance < 0 || isNaN(countDownDate)) {
    document.querySelector('.main_cdays .wb_cdays').textContent = "00";
    document.querySelector('.main_chours .wb_chours').textContent = "00";
    document.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
    document.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
  }
  else {  
    document.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
    document.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    document.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    document.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('rk-fit-title')) {
    customElements.define('rk-fit-title', class extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('h1');
        if (!this.heading) return;
        this.lastWidth = 0;
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.fit();
          }
        });
        this.observer.observe(this);
        document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
        this.fit();
      }
      fit() {
        const width = this.clientWidth;
        if (!width) return;
        this.heading.style.removeProperty('font-size');
        const maximum = parseFloat(getComputedStyle(this.heading).fontSize);
        const range = document.createRange();
        range.selectNodeContents(this.heading);
        this.heading.style.whiteSpace = 'nowrap';
        let low = 0;
        let high = maximum;
        for (let i = 0; i < 14; i++) {
          const size = (low + high) / 2;
          this.heading.style.fontSize = `${size}px`;
          if (range.getBoundingClientRect().width <= width - 1) low = size;
          else high = size;
        }
        this.heading.style.fontSize = `${Math.floor(low * 100) / 100}px`;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokka-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rokka-brands')) {
    customElements.define('rokka-brands', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const button = this.querySelector('button');
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokka-product-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rokka-daily-banners')) {
    customElements.define('rokka-daily-banners', class extends HTMLElement {
      static dayNumber(date = new Date(), timeZone = 'America/Chicago') {
        let formatter;
        try { formatter = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }); }
        catch { formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }); }
        const parts = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
        return Math.floor(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000);
      }
      static select(pools, day) {
        const used = new Set();
        const reserved = new Set();
        return pools.map((pool, slot) => {
          const eligible = pool.products.filter(product => product.available && product.image).sort((a, b) => String(a.id).localeCompare(String(b.id), 'en', { numeric: true }));
          const dedicated = eligible.filter(product => !reserved.has(String(product.id)));
          const products = dedicated.length > 1 ? dedicated : eligible;
          eligible.forEach(product => reserved.add(String(product.id)));
          for (let offset = 0; offset < products.length; offset++) {
            const item = products[(day + slot + offset) % products.length];
            if (!used.has(String(item.id))) { used.add(String(item.id)); return item; }
          }
          return null;
        });
      }
      connectedCallback() {
        this.pools = JSON.parse(this.querySelector('[data-daily-pools]').textContent);
        this.render();
        this.onVisibility = () => { if (!document.hidden) this.checkDay(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.timer = setInterval(() => this.checkDay(), 60000);
      }
      render() {
        this.day = this.constructor.dayNumber(new Date(), this.dataset.timeZone);
        const selected = this.constructor.select(this.pools, this.day);
        this.pools.forEach((pool, index) => {
          const card = this.querySelector(`[data-daily-slot="${CSS.escape(pool.block)}"]`);
          if (!card) return;
          const item = selected[index];
          card.hidden = !item;
          if (!item) return;
          card.href = item.url;
          card.dataset.productId = item.id;
          card.setAttribute('aria-label', item.title);
          card.querySelector('.rp-banner-brand').textContent = item.vendor;
          card.querySelector('h2').textContent = item.title.length > 65 ? item.title.slice(0, 62).trimEnd() + '…' : item.title;
          card.querySelector('p').textContent = item.price;
          const image = card.querySelector('img');
          image.src = item.image;
          image.srcset = [240, 400, 600].map(width => {
            const url = new URL(item.image, window.location.origin);
            url.searchParams.set('width', String(width));
            return `${url.href} ${width}w`;
          }).join(', ');
          image.alt = item.title;
        });
      }
      async checkDay() {
        if (this.loading || this.day === this.constructor.dayNumber(new Date(), this.dataset.timeZone)) return;
        this.loading = true;
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.href, { signal: AbortSignal.timeout(10000) });
          if (!response.ok) return;
          const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = markup.querySelector('rokka-daily-banners');
          if (!fresh || !this.isConnected) return;
          this.pools = JSON.parse(fresh.querySelector('[data-daily-pools]').textContent);
          this.querySelector('.rp-banners').replaceWith(fresh.querySelector('.rp-banners'));
          this.render();
        } catch { }
        finally { this.loading = false; }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokka-welcome-popup"]) return;
  try {
    
  if (!customElements.get('rokka-welcome-popup')) {
    customElements.define('rokka-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.key = 'rokka-welcome-10-v1';
        this.storage = (type, action, key, value) => {
          try { return window[type][action](key, value); } catch { return null; }
        };
        const success = this.querySelector('[data-welcome-success]');
        const submittedAt = Number(this.storage('sessionStorage', 'getItem', `${this.key}-pending`) || 0);
        const pending = submittedAt > 0 && Date.now() - submittedAt < 15 * 60 * 1000;
        const posted = success.dataset.posted === 'true' && pending;
        const error = this.querySelector('[data-welcome-error]') && pending;
        if (posted) {
          this.querySelector('[data-welcome-signup]').hidden = true;
          success.hidden = false;
          this.storage('localStorage', 'setItem', `${this.key}-joined`, 'true');
          this.storage('sessionStorage', 'removeItem', `${this.key}-pending`);
        }
        this.querySelector('form').addEventListener('submit', () => {
          this.storage('sessionStorage', 'setItem', `${this.key}-pending`, String(Date.now()));
        });
        this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dismiss()));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dismiss();
        });
        const dismissed = Number(this.storage('localStorage', 'getItem', `${this.key}-dismissed`) || 0);
        const joined = this.storage('localStorage', 'getItem', `${this.key}-joined`);
        const suppressed = joined || Date.now() - dismissed < Number(this.dataset.dismissDays) * 86400000;
        if (posted || error) this.open();
        else if (!suppressed && !window.Shopify?.designMode) this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }
      open() {
        if (!this.isConnected || this.dialog.open) return;
        if (document.querySelector('dialog[open]') || Array.from(document.querySelectorAll('.shopify-pc__banner__dialog')).some(banner => banner.getClientRects().length > 0)) {
          this.timer = setTimeout(() => this.open(), 2000);
          return;
        }
        this.dialog.showModal();
      }
      dismiss() {
        this.storage('localStorage', 'setItem', `${this.key}-dismissed`, String(Date.now()));
        this.storage('sessionStorage', 'removeItem', `${this.key}-pending`);
        this.dialog.close();
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
